import { CronExpressionParser } from 'cron-parser'
import { z } from 'zod'

export const schedulerCronPattern = z
  .string()
  .trim()
  .min(1)
  .superRefine((value, ctx) => {
    try {
      CronExpressionParser.parse(value)
    } catch (error) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: error instanceof Error ? error.message : 'Invalid cron expression',
      })
    }
  })

export const schedulerUpdateBody = z.object({
  pattern: schedulerCronPattern,
  tz: z.string(),
  active: z.boolean(),
})

export const schedulerListItem = z.object({
  schedulerId: z.string(),
  label: z.string(),
  pattern: z.string(),
  tz: z.string(),
  next: z.number().nullable(),
  iterationCount: z.number(),
  active: z.boolean(),
  inngestEvent: z.string(),
})

export type SchedulerListItem = z.infer<typeof schedulerListItem>
export type SchedulerUpdateBody = z.infer<typeof schedulerUpdateBody>
